function Menu() {
  return (
    <section className="gold h-max py-[80px]">
      <h1 className="text-center head text-[5rem] ">
        Cake your day with piece of love{" "}
      </h1>{" "}
      <div className="flex justify-evenly mt-[50px] px-[10%] flex-wrap">
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img1 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Manila Deux </h1>{" "}
          <p className="text-[1.2rem]"> $ 8.00 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img2 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Valencia </h1>{" "}
          <p className="text-[1.2rem]"> $ 14.00 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img3 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Hawaii Tarte </h1>{" "}
          <p className="text-[1.2rem]"> $ 12.50 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img4 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Toulouse </h1>{" "}
          <p className="text-[1.2rem]"> $ 9.50 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img5 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> La Rochelle </h1>{" "}
          <p className="text-[1.2rem]"> $ 11.00 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img6 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Dominicana </h1>{" "}
          <p className="text-[1.2rem]"> $ 10.00 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img7 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> La Lavandou </h1>{" "}
          <p className="text-[1.2rem]"> $ 9.50 </p>{" "}
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[350px]  items-center justify-between">
          <div className="menu-img8 bg-img h-[100%] w-[100%]"> </div>{" "}
          <h1 className="head text-[3.5rem]"> Pasadena </h1>{" "}
          <p className="text-[1.2rem]"> $ 12.00 </p>{" "}
        </div>{" "}
      </div>{" "}
    </section>
  );
}
export { Menu };
